// Template277: Pekín - Apps imprescindibles (AppsImprescindiblesPekin.jsx)
// Cabecera, intro, lista apps (nombre, uso), caja amarilla consejo.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template277 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const tipConsejo = page?.texts?.[2]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const apps = Array.isArray(page?.data?.apps) ? page.data.apps : [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const stickerAlipay = getImageSrc("sticker-alipay");

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.75 }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.25,
						position: "relative",
					}}
				>
					{apps.map((app, idx) => (
						<Box
							key={app.nombre}
							data-block-id={`text-${idx + 3}`}
							sx={{
								backgroundColor: "#fff",
								borderRadius: "12px",
								padding: "12px 14px",
								border: "2px solid #e8e8e8",
							}}
						>
							<Box
								sx={{
									fontWeight: 700,
									fontSize: 13,
									color: actualHeaderColor,
									marginBottom: 0.75,
								}}
							>
								{app.nombre}
							</Box>
							{app.uso && (
								<Box
									component="p"
									sx={{ ...estiloP, fontSize: 13, margin: 0, lineHeight: 1.5 }}
								>
									{app.uso}
								</Box>
							)}
						</Box>
					))}
					{tipConsejo && (
						<Box
							data-block-id="text-consejo"
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -120 : -100,
								left: 80,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: isSmallScreen ? 260 : 320,
								zIndex: 2,
							}}
						>
							{tipConsejo}
						</Box>
					)}
					{stickerAlipay && (
						<img
							src={stickerAlipay}
							alt=""
							style={{
								width: 95,
								position: "absolute",
								bottom: isSmallScreen ? -160 : -130,
								left: 0,
							}}
						/>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template277.thumbnail = "/images/template-1.png";
export default Template277;
